import { environment } from 'src/environments/environment';

const FLAG = 'access-bounce-at';
/** One bounce per minute at most: a second refusal right after one means Access said no. */
const QUIET_MS = 60_000;

/**
 * On dev the admin API is behind Cloudflare Access (specs/todo/dev-chiuso.md), which logs a
 * browser in per hostname and only on a top-level navigation. The console's calls are cross-origin
 * XHR: until the browser holds the Access cookie for the API host they are redirected to the login
 * and fail. So, before anything else, one call: if Access turns it away, the console navigates to
 * the API's /access-bounce, Access logs the user in and sets the cookie there, and the node
 * redirects back to where the console was. Off everywhere but dev.
 */
export async function accessBounce(): Promise<void> {
  // Only in a browser: the build prerenders the routes on the server, where there is no window to
  // navigate and no cookie to get, and where Access, turning the call away, would fail the build.
  if (!environment.ACCESS_BOUNCE || typeof window === 'undefined') {
    return;
  }
  let through = false;
  try {
    const res = await fetch(`${environment.RH_BASE_URL}/ping`, { credentials: 'include', redirect: 'manual' });
    through = res.type !== 'opaqueredirect' && res.ok;
  } catch {
    through = false;
  }
  if (through) {
    return;
  }
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(FLAG) ?? 0);
  } catch {
    // storage blocked: bounce anyway, the time check below is only a guard against loops
  }
  if (Date.now() - last < QUIET_MS) {
    return;
  }
  try {
    sessionStorage.setItem(FLAG, String(Date.now()));
  } catch {
    // see above
  }
  window.location.href = `${environment.RH_BASE_URL}/access-bounce?to=${encodeURIComponent(window.location.href)}`;
  // the page is leaving: hold the bootstrap so nothing else calls the API meanwhile
  await new Promise<void>(() => undefined);
}
